/**
 * Basket line operation thunks.
 */

// Basket line operations live here, not in the checkout app, so non-checkout
// apps can dispatch them without importing a sibling app;
// `apps/checkout/thunks` re-exports them.
//
// Caveat: they all still call checkout's `loadBasket`, so consumers keep a
// transitive dependency on apps/checkout that neither eslint nor
// audit-app-boundaries.mts can see (both only cover `apps/`).
// Tracked in #35835.
// The reads, re-exported from their concrete modules for the same reason the
// mutations live here: a caller outside the checkout app should name the
// basket, not a sibling app. Concrete modules rather than
// `apps/checkout/thunks`, which re-exports this file and would cycle.
export { loadBasket } from "../../../apps/checkout/thunks/loadBasket";
export { loadBasketIfOutdated } from "../../../apps/checkout/thunks/loadBasketIfOutdated";

export { addBasketLine } from "./addBasketLine";
export { addBasketLines } from "./addBasketLines";
export { removeBasketLine } from "./removeBasketLine";
export {
    isBasketLineStockError,
    updateBasketLineQuantity,
} from "./updateBasketLineQuantity";
